export default __webpack_public_path__ + "static/media/futuregrowth_3.a590b5bd.png";